export default __webpack_public_path__ + "resources/icons/d230-a204.png";